import {RouteConfig} from 'vue-router/types/router';

/** Acquisition lists, a list, a school of a list and the acquisition overview (plus old status page links) */
export const ACQUISITION_ROUTES: RouteConfig[] = [
    {
        path: '/acquisitionLists',
        name: 'Akquiselisten',
        component: () => import (/* webpackChunkName: "acquisition-lists" */ '@/views/AcquisitionLists.vue'),
    },
    {
        path: '/acquisitionLists/:acquisitionListId',
        name: 'Akquiseliste',
        component: () => import(/* webpackChunkName: "acquisition-list" */ '@/views/AcquisitionList.vue'),
    },
    {
        path: '/acquisitionLists/:acquisitionListId/:institutionId',
        name: 'Akquisestandort',
        component: () => import(/* webpackChunkName: "acquisition-list-institution" */ '@/views/AcquisitionListItem.vue'),
    },
    {
        path: '/acquisitionListsOverview',
        name: 'Akquiseübersicht',
        component: () => import(/* webpackChunkName: "acquisition-overview" */ '@/views/AcquisitionListsOverview.vue'),
    },
    {
        // Former status page, now a tab of the overview
        path: '/acquisitionListsOverview/progress',
        redirect: {path: '/acquisitionListsOverview', query: {s: '3'}},
    },
    {
        // Former status page, now a tab of the overview
        path: '/acquisitionListsOverview/committed',
        redirect: {path: '/acquisitionListsOverview', query: {s: '1'}},
    },
    {
        // Former status page, now a tab of the overview
        path: '/acquisitionListsOverview/closed',
        redirect: {path: '/acquisitionListsOverview', query: {s: '2'}},
    },
    {
        // Former status page, now a tab of the overview
        path: '/acquisitionListsOverview/potential',
        redirect: {path: '/acquisitionListsOverview', query: {s: '4'}},
    },
    {
        // Former status page, now a tab of the overview
        path: '/acquisitionListsOverview/ai-success',
        redirect: {path: '/acquisitionListsOverview', query: {s: '5'}},
    },
    {
        // Former status page, now a tab of the overview
        path: '/acquisitionListsOverview/open',
        redirect: {path: '/acquisitionListsOverview', query: {s: '0'}},
    },
];
